<!-- TOP NAV -->
<nav class="navbar app-bg-dark-gray app-text-white p-1 sticky-footer">

  <span *ngIf="showRecords">Records Listed: {{writeupListLength$ | async}}</span>
  <span *ngIf="!showRecords"></span>

  <button class="btn btn-sm rounded-pill border-white app-bg-blue float-right app-text-white" (click)="feedback()">
    FEEDBACK
  </button>
</nav>